import type { Reactive, Ref } from 'vue';
import type { Pagination } from '@/types/option';
import type { List, ListEntry } from '@/types/list';
import { date } from 'quasar';
import formatDate = date.formatDate;

export function Reset<T extends Reactive<object>>(formData: T): void {
  for (const key in formData) {
    if (Object.prototype.hasOwnProperty.call(formData, key)) {
      const item = formData[key];
      if (typeof item === 'object' && item !== null && 'reset' in item && typeof item.reset === 'function') {
        item.reset();
      } else {
        // Reset primitive types or simple objects to their defaults
        formData[key] = getDefaultValue(item);
      }
    }
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getDefaultValue(value: any): any {
  if (Array.isArray(value)) {
    return []; // Reset arrays to empty
  } else if (typeof value === 'object') {
    return {}; // Reset objects to empty object
  } else if (typeof value === 'string') {
    return ''; // Reset strings to empty
  } else if (typeof value === 'number') {
    return 0; // Reset numbers to 0
  } else if (typeof value === 'boolean') {
    return false; // Reset booleans to false
  }
  return null; // Default to null if type is not handled
}

export function setPagination(data: List, rows: Ref<ListEntry[]>, pagination: Ref<Pagination>, loaded: Ref<boolean>, count?: boolean) {
  if (count) {
    rows.value = [];
    loaded.value = false;
    pagination.value.rowsNumber = 0;
    pagination.value.lastId = null;
    pagination.value.rowsNumber = data.count;
  }

  if (data.entries == null) {
    loaded.value = true;
    return;
  }

  rows.value = rows.value.concat(...data.entries);

  rows.value.forEach((row: ListEntry, index) => {
    row.index = index + 1;
    row.created_at = formatDate(row.created_at, 'DD.MM.YYYY HH:mm:ss')
    row.updated_at = formatDate(row.updated_at, 'DD.MM.YYYY HH:mm:ss')
  });

  pagination.value.lastId = (data.entries[data.entries.length - 1] ?? { id: null }).id;
}
